import React, { useState } from "react";
import "../../../Styles/RedesSociales/_RSTipoPublicacionModal.scss";

// Primer paso al dar "+ Añadir": elegir tipo de publicación y, si es Reel, el modo (Manual/Automático)
export const RSTipoPublicacionModal = ({ open, onClose, onSeleccionar }) => {
    const [paso, setPaso] = useState("tipo");

    if (!open) return null;

    const cerrar = () => {
        setPaso("tipo");
        onClose();
    };

    const onElegirTipo = (tipo) => {
        if (tipo === "Reel") setPaso("modoReel");
        else onSeleccionar(tipo);
    };

    const onElegirModoReel = (modo) => {
        setPaso("tipo");
        onSeleccionar("Reel", modo);
    };

    return (
        <div className="rs-modal-overlay" onClick={cerrar}>
            <div className="rs-modal rs-tipo-modal" onClick={e => e.stopPropagation()}>

                <div className="rs-modal__header">
                    <span className="rs-modal__title">Nueva Publicación</span>
                    <button className="rs-modal__close" onClick={cerrar}>✕</button>
                </div>

                {paso === "tipo" && (
                    <div className="rs-modal__body">
                        <p className="rs-tipo-modal__hint">¿Qué tipo de publicación quieres crear?</p>

                        <div className="rs-tipo-modal__opciones">
                            <button className="rs-tipo-modal__opcion" onClick={() => onElegirTipo("Imagen")}>
                                <span className="rs-tipo-modal__icono">🖼️</span>
                                <span className="rs-tipo-modal__label">Imágenes</span>
                            </button>

                            <button className="rs-tipo-modal__opcion rs-tipo-modal__opcion--reel" onClick={() => onElegirTipo("Reel")}>
                                <span className="rs-tipo-modal__icono">▶</span>
                                <span className="rs-tipo-modal__label">Reels</span>
                            </button>
                        </div>
                    </div>
                )}

                {paso === "modoReel" && (
                    <div className="rs-modal__body">
                        <p className="rs-tipo-modal__hint">¿Cómo quieres crear el reel?</p>

                        <div className="rs-tipo-modal__opciones">
                            <button className="rs-tipo-modal__opcion" onClick={() => onElegirModoReel("Automatico")}>
                                <span className="rs-tipo-modal__icono"></span>
                                <span className="rs-tipo-modal__label">Automático</span>
                            </button>

                            <button className="rs-tipo-modal__opcion rs-tipo-modal__opcion--reel" onClick={() => onElegirModoReel("Manual")}>
                                <span className="rs-tipo-modal__icono"></span>
                                <span className="rs-tipo-modal__label">Manual</span>
                            </button>
                        </div>

                        <button className="rs-btn rs-btn--ghost rs-tipo-modal__volver" onClick={() => setPaso("tipo")} type="button">
                            ← Volver
                        </button>
                    </div>
                )}

            </div>
        </div>
    );
};

export default RSTipoPublicacionModal;